import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Row, Col } from "react-bootstrap";
import Modal from "react-modal";
import { fetchBroadcastTemplatesData } from "../../../../redux/ad-blog-reducers/blogSlice";
import TemplateForm from "./TemplateForm";
import CommonStructured from "../../../common-components/CommonStructured";
import CmnFilters from "../../../lead-management/common/CmnFilters";
import TemplateListings from "./TemplateListings";
import ModalHeadAndClose from "../../../payouts-wtf/common/ModalHeadAndClose";

const EmailTemplateStructure = ({ userInfoData }) => {
  const dispatch = useDispatch();
  const { broadcastTemplatesLoading } = useSelector((state) => state.blog);

  const [isPage, setIsPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);

  const iniAllFilter = {
    selectedTemplateCategory: "",
    isActive: "",
    searchString: "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilter);
  const iniFilters = {
    page: isPage + 1,
    limit: pageLimit || 10,
    category: allFilters.selectedTemplateCategory?.value || "",
    status: allFilters.isActive?.value || "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);
  const iniModValues = {
    isModOpen: false,
    modName: "",
    rowData: "",
  };
  const [modValues, setModValues] = useState(iniModValues);

  const onClickSearch = () => {
    setIsPage(0);
    if (allFilters.searchString) {
      setSearchFilterApplied(true);
      setFilters((prevs) => ({ ...prevs, search: allFilters.searchString }));
    }
  };

  const onResetFilters = () => {
    setAllFilters(iniAllFilter);
    setFilters(iniFilters);
  };

  const onCloseModal = () => {
    setModValues(iniModValues);
  };

  const getTemplates = (filters) => {
    dispatch(
      fetchBroadcastTemplatesData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  };

  useEffect(() => {
    getTemplates(filters);
  }, [filters]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      limit: pageLimit || 10,
      category: allFilters.selectedTemplateCategory?.value || "",
      status: allFilters.isActive?.value || "",
    }));
  }, [
    isPage,
    pageLimit,
    allFilters.selectedTemplateCategory,
    allFilters.isActive,
  ]);

  useEffect(() => {
    if (allFilters.searchString?.length === 0) {
      setSearchFilterApplied(false);
      setFilters((prevs) => ({ ...prevs, search: "" }));
      setIsPage(0);
    }
  }, [allFilters.searchString]);

  return (
    <>
      <Modal
        isOpen={modValues.isModOpen}
        onRequestClose={onCloseModal}
        contentLabel="Detail Modal"
        ariaHideApp={false}>
        <div className="createNewCTOModalContainer mod-width-50p">
          <ModalHeadAndClose
            title={
              modValues.modName === "description"
                ? modValues.rowData?.template_name?.replace(/_/g, " ")
                : modValues.modName === "add" || modValues.modName === "edit"
                ? `${modValues.modName?.replace(/_/g, " ")} Template`
                : "Template Details"
            }
            onClose={onCloseModal}
          />

          {modValues.modName === "description" ? (
            <div className="discussionModalMessage mt30">
              <p
                className="message"
                dangerouslySetInnerHTML={{
                  __html: modValues.rowData?.body || "No Content Available",
                }}></p>
            </div>
          ) : modValues.modName === "add" || modValues.modName === "edit" ? (
            <TemplateForm
              isEdit={modValues.modName === "edit"}
              rowData={modValues.rowData}
              closeModal={onCloseModal}
              userInfoData={userInfoData}
              callFunction={() => getTemplates(filters)}
            />
          ) : null}
        </div>
      </Modal>

      <Row>
        <Col>
          <CommonStructured
            pageHeading={"Broadcast Email Templates"}
            isReload={() => getTemplates(filters)}
            createBtnTxt={"+ Add New Email Template"}
            onClickCreateBtn={() =>
              setModValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                modName: "add",
              }))
            }
          />
        </Col>
      </Row>

      <Row>
        <Col>
          <CmnFilters
            from="broadcast-templates"
            userInfoData={userInfoData}
            searchFilterApplied={searchFilterApplied}
            filters={allFilters}
            setFilters={setAllFilters}
            onClickSearch={onClickSearch}
            onClickReset={onResetFilters}
            isLoading={broadcastTemplatesLoading}
            searchPlaceHolder="Search by template name..."
          />
        </Col>
      </Row>

      <Row>
        <Col>
          <TemplateListings
            isPage={isPage}
            setIsPage={setIsPage}
            pageLimit={pageLimit}
            setPageLimit={setPageLimit}
            setModValues={setModValues}
            userInfoData={userInfoData}
            callFunction={() => getTemplates(filters)}
          />
        </Col>
      </Row>
    </>
  );
};

export default EmailTemplateStructure;
